import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { withRouter } from 'react-router-dom';
import {
  CardElement,
  useStripe,    
  useElements,  
} from '@stripe/react-stripe-js';
import { Redirect } from 'react-router-dom';

import {
  SavedCardDetails,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperAccountSettingsSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  Page,
  UserNav,
  Button
} from '../../components';
import { TopbarContainer } from '../../containers';
import css from './StripeSubscriptions.module.css';

const sharetribeSdk = require('sharetribe-flex-sdk');

const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });
  


const Subscribe = ({location}) => {
  const title = "Abonnements";
  // Get the lookup key for the price from the previous page redirect.
  const [clientSecret] = useState(location.state.clientSecret); 
  const [subscriptionId] = useState(location.state.subscriptionId); 
  const [priceId] = useState(location.state.priceId); 
  const [userName] = useState(location.state.userName); 
  const [userPrivateData] = useState(location.state.userPrivateData);
  const [name, setName] = useState(userName);
  const [messages, _setMessages] = useState('');
  const [paymentIntent, setPaymentIntent] = useState();
  const [updatedPrivateData, setUpdatedPrivateData] = useState(false);

  // helper for displaying status messages.
  const setMessage = (message) => {
    _setMessages(`${messages}\n\n${message}`);
  }

  // Initialize an instance of stripe.
  const stripe = useStripe();     
  const elements = useElements();  

  if (!stripe || !elements) {   
    // Stripe.js has not loaded yet. Make sure to disable
    // form submission until Stripe.js has loaded.
    return '';   
  } 

  // When the subscribe-form is submitted we do a few things:
  //
  //   1. Tokenize the payment method
  //   2. Create the subscription
  //   3. Handle any next actions like 3D Secure that are required for SCA.
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

      const privateData = userPrivateData;

      if(privateData && privateData.subscriptions){

                            // Use card Element to tokenize payment details
                            return stripe.confirmCardPayment(clientSecret, {
                              payment_method: {
                                card: cardElement,
                                billing_details: {
                                  name: name,
                                }
                              }
                            }).then(resp => {
                                      const error = resp.error;
                                      const paymentIntent = resp.paymentIntent;

                                      if(error) {
                                        // show error and collect new card details.
                                        setMessage(error.message);
                                        return;
                                      }
                                      setPaymentIntent(paymentIntent);
          
          
                                      if(paymentIntent && paymentIntent.status === 'succeeded') {
                                                  const subscriptions = [...privateData.subscriptions]
                                                  sdk.currentUser.updateProfile({
                                                  privateData: {
                                                    subscriptions: [...subscriptions, priceId]
                                                  }
                                                }).then(resp => {
                                                setUpdatedPrivateData(true)
                                                }).catch(e => console.log(e))
          
                                      }


                            }).catch(e => console.log(e));

      }else{    


                        // Use card Element to tokenize payment details
                        return stripe.confirmCardPayment(clientSecret, {
                          payment_method: {
                            card: cardElement,
                            billing_details: {
                              name: name,
                            }
                          }
                        }).then(resp => {
                              const error = resp.error;
                              const paymentIntent = resp.paymentIntent;

                              if(error) {
                                // show error and collect new card details.
                                setMessage(error.message);
                                return;
                              }
                              setPaymentIntent(paymentIntent);
      
      
                              if(paymentIntent && paymentIntent.status === 'succeeded') {
      
                                        sdk.currentUser.updateProfile({
                                          privateData: {
                                            subscriptions: [priceId]
                                          }
                                        }).then(resp => {
                                        setUpdatedPrivateData(true)
                                      }).catch(e => console.log(e))
      
                              }
      

                        }).catch(e => console.log(e));

    
      }


    

  }

  if(paymentIntent && paymentIntent.status === 'succeeded' && updatedPrivateData) {

    return <Redirect to={{pathname: '/subscriptions'}} />

  }

  return (

    <Page title={title}>
    <LayoutSideNavigation>
      <LayoutWrapperTopbar>
        <TopbarContainer
          currentPage="StripeAccountSubscriptionsPage"
          desktopClassName={css.desktopTopbar}
          mobileClassName={css.mobileTopbar}
        />
        <UserNav selectedPageName="StripeAccountSubscriptionsPage" />
      </LayoutWrapperTopbar>
      <LayoutWrapperAccountSettingsSideNav currentTab="StripeAccountSubscriptionsPage" />
      <LayoutWrapperMain>
                      <div className={css.content}>
                        
                    <h1>Subscribe</h1>

                
                    <br/>

                    <form onSubmit={handleSubmit}>
                      <label>
                        Full name
                        <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} />
                      </label>
                      <br/>
                      <CardElement />     
              

        <br/>
        <br/>
                  
                      <Button>
                        Subscribe
                      </Button>
                     

                      <div>{messages}</div>
                    </form>

        </div>
      </LayoutWrapperMain>
      <LayoutWrapperFooter>
        <Footer />
      </LayoutWrapperFooter>
    </LayoutSideNavigation>
  </Page>
  )
}

export default withRouter(Subscribe);
